var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgCapRxJudiLogoGraphic = function SvgCapRxJudiLogoGraphic(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "29px",
    viewBox: "0 0 192 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96 192C149.019 192 192 149.019 192 96C192 42.9807 149.019 0 96 0C42.9807 0 0 42.9807 0 96C0 149.019 42.9807 192 96 192Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3963 80.2477V113.139V146.031C114.526 146.031 129.288 131.269 129.288 113.139C129.288 95.0093 114.526 80.2477 96.3963 80.2477Z",
    fill: "#0075C9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7585 113.238V146.13H73.3127C64.1982 146.13 56.8669 138.799 56.8669 129.684C56.8669 120.57 64.1982 113.238 73.3127 113.238H89.7585Z",
    fill: "#0195D7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3963 72.8173C110.266 72.8173 122.452 80.1486 129.288 91.2446V56.3715C129.288 47.257 121.957 39.9257 112.842 39.9257C103.728 39.9257 96.3963 47.257 96.3963 56.3715V72.8173Z",
    fill: "#0195D7"
  })));
};
export { SvgCapRxJudiLogoGraphic as ReactComponent };
export default __webpack_public_path__ + "static/media/CapRx-JUDILogoGraphic.2ca56115.svg";